
import { Component, Mixins } from "vue-property-decorator";
import { BarcodeStyle, BarcodeKinds, QrCodeStyle } from "../../../../../../documaker/domain/format/objects";
import { IBarcodeStylePropertyEditable, instanceOfIBarcodeStylePropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class BarcodeStylePropertyEditableMixin extends Mixins() {
  writePropertyWhenValid: (writer: (source: IBarcodeStylePropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IBarcodeStylePropertyEditable) => T, defaultValue: T) => T;

  get isBarcodeStylePropertyEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIBarcodeStylePropertyEditable(s) && s.barcodeStyle().isEditable(), false);
  }

  get barcodeStyle(): BarcodeStyle {
    return this.readPropertyOrDefault(s => BarcodeStyle.from(s.barcodeStyle().getValue()), new BarcodeStyle(BarcodeKinds.Qr, "", new QrCodeStyle(3, 1)));
  }

  set barcodeStyle(value: BarcodeStyle) {
    this.writePropertyWhenValid(s => s.barcodeStyle().setValue(BarcodeStyle.to(value)));
  }
}

